import { ManageYourTeamPage } from '@weirgroup/cde-iam-accessmanagement-app'
import { history } from '../../utils/history.util'
import "./styles.scss"
import { useDarkMode } from '../../hooks/use-darkmode'
// import store from '../../redux/store'
export const ManageYourTeam = (props: any) => {
    const {darkMode} = useDarkMode()
    return (
        <div className='manage-your-team-container'>
        <ManageYourTeamPage
            // store={store}
            darkMode={darkMode}
            history={history}
            handleProgressAction
            appName="/trackpro"
            applicationID={process.env.REACT_APP_MSAL_CLIENT_ID}
            sourceSystemName={'IamServices'}
        />
        </div>
    )
}
